import React, {
  useEffect,
  useState,
  useRef,
  useContext,
} from "react";
import { firestore } from "../firebase/firebase";
import { makeStyles } from "@material-ui/core/styles";
import { DataGrid } from "@material-ui/data-grid";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import {
  // BrowserRouter as Router,
  // Switch,
  Route,
  // Link,
  useHistory,
  Redirect,
} from "react-router-dom";

import { UserContext } from "../providers/UserProvider";

import { Button } from "@material-ui/core";

import AddIcon from "@material-ui/icons/Add";



function AdminUsers() {
  const { user } = useContext(UserContext);
  const isMounted = useRef(false);

  const [adminUsers, setAdminUsers] = useState([]);

  let history = useHistory();

  useEffect(() => {
    isMounted.current = true;
    const init = async () => {
      getAdminUsers();
    };
    init();

    return () => {
      isMounted.current = false;
    };

  }, []);

  const handleRowClick = (param) => {
    const uid = param.row.id;
    history.push("/admin-anvandare/" + uid);
  };

  const getAdminUsers = async () => {
    try {
      const usersSnapshot = await firestore
        .collection("adminUsers")
        .get();
      const users = [];
      usersSnapshot.forEach((userSnapshot, index) => {
        const data = userSnapshot.data();
        users.push({
          id: userSnapshot.id,
          ...data,
        });
      });
      isMounted.current && setAdminUsers(users);
    } catch (error) {
      console.error(error);
    }
  };

  const classes = useStyles();

  const columns = [
    // { field: "id", headerName: "ID", width: 350 },
    { field: "displayName", headerName: "Namn", width: 250 },
    { field: "email", headerName: "Mejl", width: 250 },
    { field: "accessLevel", headerName: "Roll", width: 100 },
  ];

  const rows = [];
  adminUsers.forEach((user, index) => {
    user.id &&
      rows.push({
        id: user.id,
        displayName: user.firstName + " " + user.lastName,
        email: user.email,
        accessLevel: user.accessLevel,
      });
  });

  return (
    <Route
      render={() =>
        user.accessLevel === 10 ? (
          <div style={{ textAlign: "left" }}>
            <Typography
              component="h1"
              variant="h5"
              color="primary"
              style={{ textAlign: "left", marginBottom: 30 }}
            >
              Admin-användare
            </Typography>
            <Button
              variant="outlined"
              color="primary"
              style={{
                marginTop: 9,
                marginLeft: 0,
                marginBottom: 20,
              }}
              onClick={() => history.push("/admin-anvandare/ny/")}
              startIcon={<AddIcon />}
            >
              Lägg till användare
            </Button>
            <Paper className={classes.paper}>
              <div
                style={{ height: 400, width: "100%" }}
                className={classes.root}
              >
                <DataGrid
                  columns={columns}
                  rows={rows}
                  pageSize={10}
                  onRowClick={handleRowClick}
                />
              </div>
            </Paper>
          </div>
        ) : (
          <Redirect to="/" />
        )
      }
    />
  );
}

export default AdminUsers;




const useStyles = makeStyles((theme) => ({
  root: {
    "& div.MuiDataGrid-row": {
      cursor: "pointer",
    },
  },
  seeMore: {
    marginTop: theme.spacing(3),
    table: {
      minWidth: 650,
    },
  },
  searchForm: {
    width: "100%",
    marginBottom: 40,
  },
  searchInput: {
    width: "50%",
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  formControl: {
    marginRight: theme.spacing(1),
    width: 150,
    marginBottom: 30,
    // textAlign: 'left',
  },
  ul: {
    marginBottom: 50,
    "& li": {
      marginBottom: 10,
    },
  },
}));
